const STORAGE_KEY = "bolide_property_service_provider_assignments";

export const DATA_PROVIDER_OPTIONS = [
  {
    id: "gridwatch",
    title: "GridWatch Metering"
  },
  {
    id: "heliosync",
    title: "HelioSync Energy"
  },
  {
    id: "aquatrace",
    title: "AquaTrace Flow"
  },
  {
    id: "voltrelay",
    title: "VoltRelay Systems"
  },
  {
    id: "clearwater",
    title: "ClearWater Telemetry"
  }
];

export const DEFAULT_DATA_PROVIDER_ID = DATA_PROVIDER_OPTIONS[0].id;

export const PROPERTY_SERVICE_PROVIDER_ASSIGNMENT_DEFAULTS = {
  101: {
    "utilities-electricity": "gridwatch",
    "utilities-water": "aquatrace",
    "energy-solar": "heliosync",
    "energy-generator": "voltrelay"
  },
  102: {
    "utilities-electricity": "voltrelay",
    "utilities-water": "clearwater",
    "energy-solar": "heliosync",
    "energy-generator": "gridwatch"
  },
  103: {
    "utilities-electricity": "gridwatch",
    "utilities-water": "aquatrace",
    "energy-solar": "voltrelay",
    "energy-generator": "heliosync"
  },
  104: {
    "utilities-electricity": "voltrelay",
    "utilities-water": "clearwater",
    "energy-solar": "heliosync",
    "energy-generator": "voltrelay"
  },
  105: {
    "utilities-electricity": "gridwatch",
    "utilities-water": "aquatrace",
    "energy-solar": "heliosync",
    "energy-generator": "gridwatch"
  },
  106: {
    "utilities-electricity": "voltrelay",
    "utilities-water": "clearwater",
    "energy-solar": "gridwatch",
    "energy-generator": "heliosync"
  },
  107: {
    "utilities-electricity": "gridwatch",
    "utilities-water": "aquatrace",
    "energy-solar": "heliosync",
    "energy-generator": "voltrelay"
  },
  108: {
    "utilities-electricity": "voltrelay",
    "utilities-water": "clearwater",
    "energy-solar": "gridwatch",
    "energy-generator": "heliosync"
  },
  109: {
    "utilities-electricity": "gridwatch",
    "utilities-water": "aquatrace",
    "energy-solar": "heliosync",
    "energy-generator": "voltrelay"
  },
  110: {
    "utilities-electricity": "voltrelay",
    "utilities-water": "clearwater",
    "energy-solar": "gridwatch",
    "energy-generator": "gridwatch"
  },
  111: {
    "utilities-electricity": "gridwatch",
    "utilities-water": "aquatrace",
    "energy-solar": "heliosync",
    "energy-generator": "voltrelay"
  }
};

export const SERVICE_PROVIDER_FEEDS = [
  {
    id: "utilities-electricity",
    dashboard: "Utilities",
    title: "Electricity",
    icon: "bi bi-lightning-charge-fill",
    description: "Electricity consumption data feed",
    provider_ids: ["gridwatch", "voltrelay"],
    default_provider: "gridwatch"
  },
  {
    id: "utilities-water",
    dashboard: "Utilities",
    title: "Water",
    icon: "bi bi-droplet-fill",
    description: "Water consumption data feed",
    provider_ids: ["aquatrace", "clearwater"],
    default_provider: "aquatrace"
  },
  {
    id: "energy-solar",
    dashboard: "Energy",
    title: "Solar",
    icon: "bi bi-sun-fill",
    description: "Solar generation data feed",
    provider_ids: ["heliosync", "gridwatch"],
    default_provider: "heliosync"
  },
  {
    id: "energy-generator",
    dashboard: "Energy",
    title: "Generator",
    icon: "bi bi-fuel-pump-fill",
    description: "Generator performance data feed",
    provider_ids: ["voltrelay", "heliosync", "gridwatch"],
    default_provider: "voltrelay"
  }
];

export const DERIVED_SERVICE_PROVIDER_DASHBOARDS = [
  {
    id: "operations-overview",
    title: "Real-Time Operations",
    icon: "bi bi-pie-chart-fill"
  },
  {
    id: "savings_insights",
    title: "Savings Insights",
    icon: "bi bi-cash-coin"
  },
  {
    id: "insights-analytics",
    title: "Insights & Analytics",
    icon: "bi bi-graph-up-arrow"
  }
];

export const FIXED_SERVICE_PROVIDER_DASHBOARDS = [
  {
    id: "connectivity",
    title: "Connectivity",
    icon: "bi bi-wifi",
    provider: "LinkForge Networks",
    description: "Connectivity service provider"
  },
  {
    id: "security",
    title: "Security",
    icon: "bi bi-shield-lock-fill",
    provider: "SentraWatch Security",
    description: "Security service provider"
  }
];

function get_default_assignments() {
  return SERVICE_PROVIDER_FEEDS.reduce((assignments, feed) => {
    assignments[feed.id] = feed.default_provider;
    return assignments;
  }, {});
}

function get_property_default_assignments(property_id) {
  return {
    ...get_default_assignments(),
    ...(PROPERTY_SERVICE_PROVIDER_ASSIGNMENT_DEFAULTS[String(property_id)] || {})
  };
}

function normalize_assignments(assignments = {}) {
  return SERVICE_PROVIDER_FEEDS.reduce((normalized_assignments, feed) => {
    const selected_provider = assignments[feed.id];

    normalized_assignments[feed.id] = feed.provider_ids.includes(selected_provider)
      ? selected_provider
      : feed.default_provider;

    return normalized_assignments;
  }, {});
}

function read_stored_assignments() {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
  } catch (error) {
    return {};
  }
}

export function get_property_service_provider_assignments(property_id) {
  const stored_assignments = read_stored_assignments();

  return normalize_assignments({
    ...get_property_default_assignments(property_id),
    ...(stored_assignments[String(property_id)] || {})
  });
}

export function save_property_service_provider_assignments(property_id, assignments) {
  const stored_assignments = read_stored_assignments();
  const next_assignments = {
    ...stored_assignments,
    [String(property_id)]: normalize_assignments({
      ...get_property_default_assignments(property_id),
      ...assignments
    })
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next_assignments));
  window.dispatchEvent(new CustomEvent("bolide:service-provider-assignments-updated", {
    detail: {
      property_id,
      assignments: next_assignments[String(property_id)]
    }
  }));

  return next_assignments[String(property_id)];
}
